import { Checkbox, Col, Row } from 'antd'
import React from 'react'


const ComplianceCard = () => {
    return (
        <Row>
            <Col span={24} className='fonty'>
                Per Carrier (AT&T, Verizon, T-Mobile) requirements before a message is sent to a recipient through AppFolio, you must first have the recipient's consent before sending the first message. AppFolio captures consent where applicants, prospects, residents, vendors, and owners enter their phone numbers into our system. We do not capture consent for phone numbers that are entered into AppFolio manually or through import.
            </Col>
            <Col span={6}></Col>
            <Col span={18} style={{
                display: 'flex', justifyContent: 'start', textAlign: 'start', margin: '15px 0px'
            }} >
              <span style={{color: 'red', marginRight: '10px'}}>*</span> 
               <Checkbox required={true} className='fonty' style={{ color: 'gray' }}>By checking this box, I certify that I am capturing the consent to send text messages to the phone number I import or enter manually into Appfolio Property Manager.</Checkbox>
            </Col>

        </Row>

    )
}

export default ComplianceCard;